import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../../i18n/LanguageContext";
import "./legal.css";

function PrivacyPolicy() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const isNe = lang === "ne";

  const sections = isNe
    ? [
        { id: "pp-scope", title: "१. दायरा", body: ["यो नीति GharBhada प्रयोग गर्ने मालिक, भाडावाल र आगन्तुक सबैमा लागू हुन्छ।"] },
        { id: "pp-data", title: "२. हामीले सङ्कलन गर्ने डेटा", list: ["खाता डेटा: नाम, इमेल, फोन, भूमिका", "सूची/प्रोफाइल डेटा: ठेगाना, मूल्य, विवरण, फोटो", "आवेदन डेटा: रोजगारी, आम्दानी, सन्दर्भ, कागजात", "सञ्चार डेटा: इन-एप सन्देश र सपोर्ट इन्टर्याक्सन", "प्राविधिक डेटा: IP, ब्राउजर, लग, त्रुटि रिपोर्ट"] },
        { id: "pp-use", title: "३. डेटा प्रयोग", list: ["खाता व्यवस्थापन र प्रमाणीकरण", "सूची, आवेदन र सञ्चार सुविधा", "ठगी रोकथाम र सुरक्षा", "सेवा सुधार", "आवश्यक इमेल सूचना", "कानुनी दायित्व पूरा"] },
        { id: "pp-basis", title: "४. कानुनी आधार", list: ["सम्झौता कार्यान्वयन", "वैध हित (सुरक्षा/ठगी रोकथाम)", "सहमति (आवश्यक अवस्थामा)", "कानुनी दायित्व"] },
        { id: "pp-sharing", title: "५. डेटा साझेदारी", body: ["हामी आवश्यक अवस्थामा अन्य प्रयोगकर्ता, सेवा प्रदायक, वा नियामक निकायसँग सीमित डेटा साझेदारी गर्न सक्छौं।"], list: ["हामी व्यक्तिगत डेटा तेस्रो पक्षलाई बेच्दैनौं।"] },
        { id: "pp-documents", title: "६. कागजात व्यवस्थापन", body: ["अपलोड गरिएका कागजात आवेदन प्रक्रिया र प्रमाणिकरणका लागि मात्र प्रयोग हुन्छन्। पहुँच अधिकृत कर्मचारी र सम्बन्धित मालिकमा सीमित हुन्छ।"] },
        { id: "pp-retention", title: "७. डेटा भण्डारण अवधि", body: ["खाता सक्रिय रहँदासम्म र आवश्यक कानुनी अवधिसम्म डेटा राखिन्छ। अस्वीकृत/फिर्ता आवेदनका कागजात सामान्यतया ९० दिनभित्र मेटाइन्छ।"] },
        { id: "pp-security", title: "८. सुरक्षा उपाय", list: ["पासवर्ड bcrypt द्वारा hash गरिन्छ", "डेटा HTTPS मार्फत पठाइन्छ", "JWT आधारित प्रमाणीकरण", "रेट लिमिट र अडिट लग", "विश्वसनीय क्लाउड पूर्वाधार"] },
        { id: "pp-rights", title: "९. तपाईंका अधिकार", list: ["पहुंच (Access)", "सुधार (Correction)", "मेटाउने (Deletion)", "सीमित प्रक्रिया (Restriction)", "डेटा पोर्टेबिलिटी", "आक्षेप (Objection)"] },
        { id: "pp-cookies", title: "१०. कुकी र ट्र्याकिङ", body: ["सेसन सुरक्षा, लगइन निरन्तरता र प्रयोग विश्लेषणका लागि कुकी प्रयोग हुन्छ। थप विवरणका लागि Cookie Policy हेर्नुहोस्।"] },
        { id: "pp-transfers", title: "११. अन्तर्राष्ट्रिय ट्रान्सफर", body: ["केही सेवा प्रदायक विदेशमा हुन सक्छन्। यस्तो अवस्थामा उपयुक्त डेटा सुरक्षा उपाय लागू गरिन्छ।"] },
        { id: "pp-children", title: "१२. बालबालिका", body: ["यो सेवा १८ वर्ष मुनिका व्यक्तिका लागि होइन। नाबालकको डेटा बुझिएको अवस्थामा हटाउने प्रक्रिया गरिन्छ।"] },
        { id: "pp-changes", title: "१३. नीति परिवर्तन", body: ["यो नीति समय-समयमा अद्यावधिक हुन सक्छ। महत्वपूर्ण परिवर्तन प्लेटफर्म वा इमेलमार्फत सूचित गरिन्छ।"] },
        { id: "pp-contact", title: "१४. सम्पर्क", body: ["गोपनीयता सम्बन्धी प्रश्नका लागि हामीलाई सम्पर्क गर्नुहोस्।"] },
      ]
    : [
        { id: "pp-scope", title: "1. Scope", body: ["This policy applies to all users of GharBhada, including owners, renters, and visitors."] },
        { id: "pp-data", title: "2. Data We Collect", list: ["Account data: name, email, phone, role", "Listing/profile data: address, price, description, photos", "Application data: employment, income, references, documents", "Communication data: in-app messages and support", "Technical data: IP, browser, logs, error reports"] },
        { id: "pp-use", title: "3. How We Use Data", list: ["Account management and authentication", "Listing, application, and messaging workflows", "Fraud prevention and security", "Service improvement", "Transactional email notifications", "Legal compliance"] },
        { id: "pp-basis", title: "4. Legal Basis", list: ["Contract performance", "Legitimate interests (security/fraud prevention)", "Consent where required", "Legal obligations"] },
        { id: "pp-sharing", title: "5. Data Sharing", body: ["We share data only when necessary with other users, service providers, or legal authorities."], list: ["We do not sell personal data to third parties."] },
        { id: "pp-documents", title: "6. Document Handling", body: ["Uploaded documents are used for application and verification only, with restricted access."] },
        { id: "pp-retention", title: "7. Data Retention", body: ["Data is retained while accounts are active and for legal or dispute resolution needs. Rejected/withdrawn application documents are generally deleted within 90 days."] },
        { id: "pp-security", title: "8. Security Measures", list: ["bcrypt password hashing", "HTTPS transport encryption", "JWT-based authentication", "Rate limiting and audit logging", "Reputable cloud infrastructure"] },
        { id: "pp-rights", title: "9. Your Rights", list: ["Access", "Correction", "Deletion", "Restriction", "Portability", "Objection"] },
        { id: "pp-cookies", title: "10. Cookies and Tracking", body: ["Cookies help with session security, login continuity, and usage insights. See the Cookie Policy for details."] },
        { id: "pp-transfers", title: "11. International Transfers", body: ["Some providers may process data outside Nepal; safeguards are applied." ] },
        { id: "pp-children", title: "12. Children", body: ["The platform is intended for adults (18+). If minor data is discovered, removal steps are taken."] },
        { id: "pp-changes", title: "13. Changes to this Policy", body: ["This policy may be updated periodically. Material changes are notified by platform notice or email."] },
        { id: "pp-contact", title: "14. Contact", body: ["Contact us for privacy-related requests and questions."] },
      ];

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <button className="legal-back-btn text-white opacity-75 mb-3" onClick={() => navigate(-1)}>
            {isNe ? "← फिर्ता" : "← Back"}
          </button>
          <h1>{isNe ? "गोपनीयता नीति" : "Privacy Policy"}</h1>
          <p className="legal-meta mb-0">
            {isNe
              ? "प्रभावी मिति: जनवरी १, २०२५ · संस्करण १.० · प्लेटफर्म: GharBhada"
              : "Effective Date: January 1, 2025 · Version 1.0 · Platform: GharBhada"}
          </p>
        </div>
      </div>

      <div className="container">
        <div className="legal-card">
          <div className="legal-toc">
            <h6>{isNe ? "विषयसूची" : "Table of Contents"}</h6>
            <ol>
              {sections.map((section) => (
                <li key={section.id}>
                  <a href={`#${section.id}`}>{section.title.replace(/^\d+\.\s*/, "")}</a>
                </li>
              ))}
            </ol>
          </div>

          <div className="legal-highlight">
            {isNe
              ? "यो नीति तपाईंको व्यक्तिगत डेटा कसरी सङ्कलन, प्रयोग, भण्डारण, साझेदारी र सुरक्षा गरिन्छ भन्ने स्पष्ट गर्छ।"
              : "This policy explains how GharBhada collects, uses, stores, shares, and protects your personal data."}
          </div>

          {sections.map((section) => (
            <div className="legal-section" id={section.id} key={section.id}>
              <h2>{section.title}</h2>
              {section.body?.map((p) => (
                <p key={p}>{p}</p>
              ))}
              {section.list && (
                <ul>
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          <div className="legal-contact-box">
            <h5>{isNe ? "GharBhada गोपनीयता टोली" : "GharBhada Privacy Team"}</h5>
            <p className="mb-1 small">
              Email: <a href="mailto:privacy@gharbhada.com">privacy@gharbhada.com</a>
            </p>
            <p className="mb-1 small">
              Support: <a href="mailto:support@gharbhada.com">support@gharbhada.com</a>
            </p>
            <p className="mb-0 small">Address: Kathmandu Valley, Nepal</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
